import { render } from "./RelationSelector.vue?vue&type=template&id=02d8b9b4"
import script from "./RelationSelector.vue?vue&type=script&lang=js"
export * from "./RelationSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__